module.exports = __webpack_public_path__ + "static/media/searchbule.50db09e5.svg";